import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../MyComponents/Footer";
import heroContent from "./HeroContent";
import leftimg from "../../assets/mathLeftImg.png";
import rightimg from "../../assets/mathRightImg.png";
// import abacusJ from "../../assets/Math/Group 22.png";
// import abacus from "../../assets/Math/Group 22-1.png";
import LearningStyle from "../../MyComponents/LearningStyle";
import Testimonials from "../../MyComponents/Testimonials";
import FAQs from "../../MyComponents/FooterPages/newfaq";
import HeadSection from "../HeadSection.js";
import pencilIcon from "../../assets/pencil.png";
import API_CONFIG from "../../config/api";
// import icon1 from "../../assets/Math/Vector.png"
// import icon2 from "../../assets/Math/hugeicons_math.png"
import "../../MyComponents/PopularCourses.css";
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import { Helmet } from "react-helmet";

const courses = [
  {
    title: "Brain Train Abacus (Junior)",
    image: "Polymath-images/Math/Group 22.png",
    icon: "Polymath-images/Math/Vector.png",
    color: "#AA66CC",
    age: "Age: 12+",
    link: "/brain-train-abacus-junior"
  },
  {
    title: "Brain Train Abacus",
    image: "Polymath-images/Math/Group 22-1.png",
    icon: "Polymath-images/Math/hugeicons_math.png",
    color: "#d41414ff",
    age: "Age: 12+",
    link: "/brain-train-abacus"
  },
];

// Custom PopularCourses component for Math page
const MathPopularCourses = () => {
  const navigate = useNavigate();

  const handleBookDemoClick = () => {
    navigate("/BookADemo");
  };
  return (
    <div className="stem-container">
      <h1 className="stem-title">Our Popular Math Courses</h1>
      <div className="courses-grid">
        {courses.map((course) => (
          <div key={course.title} className="course-card">
            <Link to={course.link} className="course-link">

              <div className="course-image-container">
                <img
                  src={`${API_CONFIG.IMAGES_URL}/${course.image}`}
                  alt={course.title}
                  className="course-image"
                />
                <span className="ages-badge">{course.age}</span>
              </div>

              <div className="icon-container" style={{ backgroundColor: course.color }}>
                <img src={`${API_CONFIG.IMAGES_URL}/${course.icon}`} alt={`${course.title} icon`} className="course-icon" />
              </div>

              <p className="course-title">{course.title}</p>
            </Link>
          </div>
        ))}
      </div>
      <button className="pocustom-btn yellow-btn" onClick={handleBookDemoClick}>
        <img src={pencilIcon} alt="icon" className="pobtn-icon" />
        Book Free Demo Class
      </button>
    </div>
  );
};

const MathPortal = () => {
  const mathpage = heroContent.mathpage;

  return (
    <>
      <Helmet>
        <title>Math Courses for Kids | Abacus, Logic & Problem-Solving -- Polymath-Kids</title>
        <meta name="description" content="Polymath-Kids offers engaging math courses for kids. From Abacus to logic-based learning, boost problem-solving, sequencing & critical thinking skills." />
      </Helmet>
      {/* <GuestNav /> */}
      <HeadSection
        leftImg={"Polymath-images/mathLeftImg.png"}
        rightImg={'Polymath-images/mathRightImg.png'}
        titlePart1="Empower Young Minds"
        titlePart2="With Math Courses"
        description="A beginner-friendly course designed to introduce young minds to the world of coding. Through interactive activities and hands-on practice, students build a solid foundation in logic, sequencing, and problem-solving."
        button1Text={false}
        button2Text="Book Free Demo Class"
        button1Icon={'Polymath-images/pencil.png'}
        button2Icon={'Polymath-images/pencil.png'}
        onButton1Click={() => alert("Early bird discount clicked!")}
        onButton2Click={() => alert("Book demo clicked!")}
      />

      <MathPopularCourses />

      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};

export default MathPortal;